import jwtDecode from "jwt-decode";


// import {History} from "history";
let ImsToken = JSON.parse(localStorage.getItem("ImsToken")) 

console.log("ImsToken", ImsToken)
let role ;

if(ImsToken){
     role = jwtDecode(ImsToken).role

     console.log("role", role)
}else{
    role = []
}
 
export const isActive = (history, path) => {
    let activeScreen = history.pathname == path ? true : false
    return activeScreen;
}

export const authenticate = (data) => {
    localStorage.setItem("ImsToken", JSON.stringify(data.token));

};

export const isAuthenticated = () => {
    if (localStorage.getItem("ImsToken")) {
        return true;
    } else {
        return false;
    }
};


export const isStore = () => {
    let store = ["1", "2", "3", "4", "9"]

    let result = role?.filter(item => store.includes(item.value))

    if (result.length > 0) {
        return true
    } else {
        return false
    }

};

export const isAdminStore = () => {
    let store = ["1"]

    let result = role?.filter(item => store.includes(item.value))

    if (result.length > 0) {
        return true
    } else {
        return false
    }

};

export const isTechStore = () => {
    let store = ["2", "3", "4", "9"]

    let result = role?.filter(item => store.includes(item.value))

    if (result.length > 0) {
        return true
    } else {
        return false
    }

};

export const isSupervisor = () => {
    let store = ["7","8"]

    let result = role?.filter(item => store.includes(item.value))

    if (result.length > 0) {
        return true
    } else {
        return false
    }

};
export const isAdminSupervisor = () => {
    let store = ["8"]

    let result = role?.filter(item => store.includes(item.value))

    if (result.length > 0) {
        return true
    } else {
        return false
    }

};
export const isTechnicalSupervisor = () => {
    let store = ["7"]

    let result = role?.filter(item => store.includes(item.value))

    if (result.length > 0) {
        return true
    } else {
        return false
    }

};
export const isEmergency = () => {
    let store = ["9"]

    let result = role?.filter(item => store.includes(item.value))

    if (result.length > 0) {
        return true
    } else {
        return false
    }

};

export const isIQA = () => {
    let Iqa = ["5"]

    let result = role?.filter(item => Iqa.includes(item.value))

    if (result.length > 0) {
        return true
    } else {
        return false
    }

};
export const isInventoryAccount = () => {
    let account = ["6","12","13","14","10"]

    let result = role?.filter(item => account.includes(item.value))

    if (result.length > 0) {
        return true
    } else {
        return false
    }

};

export const isTeamLead = () => {
    let account = ["10"]

    let result = role?.filter(item => account.includes(item.value))

    if (result.length > 0) {
        return true
    } else {
        return false
    }

};

